<script setup lang="ts">
const { modelValue, items } = defineProps<{
  modelValue: Boolean,
}>()

const active: Ref<boolean> = ref(modelValue)
</script>

<template>
  <span class="menu">
    <v-icon
        @click="active = true"
        size="27" class="hidden-md-and-up"
    >las la-bars</v-icon>

    <v-expand-x-transition>
      <div v-if="active" class="menu__inner">
        <v-icon
            v-if="active"
            class="hidden-md-and-up" size="32"
            @click="active = false"
        >las la-times</v-icon>

        <slot />
      </div>
    </v-expand-x-transition>
  </span>
</template>

<style scoped lang="scss">
.menu {
  &__inner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background: #111;
    font-family: var(--font-primary);
    opacity: 0.95;
  }

  :deep(.menu__items) {
    display: grid;
    align-content: center;
    text-align: center;
    height: 100%;
    color: white;
    z-index: 2;

    ul {
      li {
        width: 100%;
        margin: 0;

        a {
          display: block;
          width: 100%;
          line-height: 50px;
          transition: all 0.2s ease-in-out;
          transform: translateX(0);
          opacity: 1;
          font-size: 20px;

          &:before {
            content: initial;
          }
        }

        &:hover a {
          transform: translateX(5px);
          opacity: 0.5;
        }
      }
    }
  }

  :deep(.v-icon) {
    cursor: pointer;
    z-index: 3;

    &.la-bars {
      margin-top: -2px;
    }

    &.la-times {
      position: absolute;
      color: white;
      top: 24px !important;
      right: 21px !important;
    }
  }
}
</style>